import { RegentsExemptionsListContainer } from './regents-exemptions-list.component';
import { RegentsExemptionsDataService } from './regents-exemptions-list-data/regents-exemptions-list-data.service';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { FixedTableModule } from '../../../shared/components/list/fixed-table/fixed-table.module';
import { FixedToInfiniteViewModule } from '../../../shared/components/list/fixed-to-infinite-view-container/fixed-to-infinite-view.module';
import { PageHeaderModule } from './../../../shared/components/header/page-header/page-header.module';
import { ListContainerModule } from './../../../shared/components/list/list-container/list-container.module';
import { MadlibModule } from './../../../shared/components/list/mad-lib/mad-lib.module';
import { SharedServicesModule } from './../../../shared/services/shared.services.module';
import { ContentToolsModule } from './../../../shell/content-tools/content-tools.module';
import { BatchActionsService } from './../services/batch-actions/batch-actions.service';
import { ListHeaderService } from './../services/list-headers/list-headers.service';
import { ListNavigationService } from './../services/list-navigation/list-navigation.service';
import { MadlibService } from './../services/madlib/madlib.service';

@NgModule({
  declarations: [RegentsExemptionsListContainer],
  imports: [
    MatMenuModule,
    CommonModule,
    ListContainerModule,
    FixedToInfiniteViewModule,
    FixedTableModule,
    ContentToolsModule,
    PageHeaderModule,
    SharedServicesModule,
    MadlibModule,
  ],
  exports: [RegentsExemptionsListContainer],
  providers: [
    RegentsExemptionsDataService,
    BatchActionsService,
    MadlibService,
    ListNavigationService,
    ListHeaderService,
  ],
})
export class RegentsExemptionsListV2Module {}
